const KNOWN_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'hotmail.com.br',
  'outlook.com',
  'outlook.com.br',
  'live.com',
  'msn.com',
  'yahoo.com',
  'yahoo.com.br',
  'icloud.com',
  'me.com',
  'uol.com.br',
  'bol.com.br',
  'terra.com.br',
  'ig.com.br',
  'globo.com',
  'proton.me',
  'protonmail.com',
]

const MAX_DISTANCE = 2

const editDistance = (a: string, b: string): number => {
  const rows = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)])
  for (let j = 1; j <= b.length; j++) rows[0][j] = j

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + cost)
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        rows[i][j] = Math.min(rows[i][j], rows[i - 2][j - 2] + 1)
      }
    }
  }

  return rows[a.length][b.length]
}

export const suggestEmail = (email: string): string | null => {
  const trimmed = email.trim().toLowerCase()
  const at = trimmed.lastIndexOf('@')
  if (at < 1 || at === trimmed.length - 1) return null

  const user = trimmed.slice(0, at)
  const domain = trimmed.slice(at + 1)
  if (KNOWN_DOMAINS.includes(domain)) return null

  let best: { domain: string; distance: number } | null = null
  for (const known of KNOWN_DOMAINS) {
    const distance = editDistance(domain, known)
    if (distance <= MAX_DISTANCE && (!best || distance < best.distance)) {
      best = { domain: known, distance }
    }
  }

  return best ? `${user}@${best.domain}` : null
}
